import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const H2 = ({children}) => <h2 className="font-display text-2xl mt-10 mb-3 tracking-tight">{children}</h2>;

export default function CookiePolicy() {
  const reopenPreferences = () => {
    try { localStorage.removeItem('agrinexus_cookie_consent_v1'); } catch {}
    location.reload();
  };
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Documenti legali</div>
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter">Cookie policy</h1>
      <p className="mt-3 text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

      <p className="mt-6 text-muted-foreground leading-relaxed">
        Questo sito usa "cookie" e tecnologie simili (localStorage, sessionStorage) per garantire il funzionamento base e — con il tuo consenso — per raccogliere statistiche anonime che ci aiutano a migliorare la piattaforma.
      </p>

      <H2>1. Cookie tecnici necessari</H2>
      <ul className="mt-3 space-y-2 text-sm text-muted-foreground list-disc pl-5">
        <li><code>agrinexus_token</code> — token JWT di autenticazione (localStorage). Scade automaticamente.</li>
        <li><code>agrinexus_user</code> — profilo utente in cache locale (localStorage).</li>
        <li><code>agrinexus_cookie_consent_v1</code> — memorizza la tua scelta sul banner cookie.</li>
      </ul>
      <p className="mt-3 text-sm text-muted-foreground">Questi non richiedono consenso: senza di loro l'accesso non funziona.</p>

      <H2>2. Cookie analitici (previa autorizzazione)</H2>
      <p className="text-sm text-muted-foreground">
        Attualmente <strong>non</strong> utilizziamo strumenti di analisi. Nel caso in cui in futuro attivassimo Plausible, Google Analytics o simili, saranno abilitati solo con il tuo consenso esplicito.
      </p>

      <H2>3. Cookie di marketing (previa autorizzazione)</H2>
      <p className="text-sm text-muted-foreground">
        Attualmente <strong>non</strong> utilizziamo strumenti di marketing/profilazione.
      </p>

      <H2>4. Gestione delle preferenze</H2>
      <p className="text-sm text-muted-foreground">
        Puoi cambiare la tua scelta in qualsiasi momento cliccando il pulsante qui sotto:
      </p>
      <div className="mt-4">
        <Button
          data-testid="cookie-reopen-prefs"
          className="rounded-full"
          onClick={reopenPreferences}
        >
          Riapri preferenze cookie
        </Button>
      </div>

      <H2>5. Cookie di terze parti</H2>
      <p className="text-sm text-muted-foreground">
        La mappa carica tile da OpenStreetMap (server esterni). L'AI comunica con OpenAI attraverso il nostro backend (nessun cookie di OpenAI viene installato lato browser).
      </p>

      <div className="mt-12 flex gap-3 text-sm">
        <Link to="/privacy" className="underline text-muted-foreground hover:text-foreground">Informativa privacy →</Link>
        <Link to="/termini" className="underline text-muted-foreground hover:text-foreground">Termini di servizio →</Link>
      </div>
    </div>
  );
}
